import type { ForkliftPose } from "../stores/telemetryStore";

/** Parking row for assets with no pose yet: just outside the floor's origin edge. */
export const PARK_Y = -3;
const PARK_X0 = 2;
const PARK_SPACING = 2.5;

/**
 * Roster-seeded forklifts that have never reported a pose (lastSeenMs === 0)
 * all carry x=0,y=0 and would render stacked inside each other at the floor
 * corner. Instead of fabricating a floor position, spread them along a
 * deterministic "parking row" outside the floor edge, ordered by id. Forklifts
 * with any real pose (lastSeenMs > 0) pass through untouched — including a
 * legitimate pose at the map origin.
 */
export function withParkedPoses(forklifts: ForkliftPose[]): ForkliftPose[] {
  const parkedIds = forklifts
    .filter((f) => !f.lastSeenMs)
    .map((f) => f.id)
    .sort();
  if (parkedIds.length === 0) return forklifts;
  const slot = new Map(parkedIds.map((id, i) => [id, i]));
  return forklifts.map((f) =>
    slot.has(f.id)
      ? { ...f, x: PARK_X0 + slot.get(f.id)! * PARK_SPACING, y: PARK_Y }
      : f,
  );
}
